import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { Loader2 } from 'lucide-react';

const AuthCallback = () => {
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const { data, error } = await supabase.auth.getSession();
        
        if (error) {
          setError(error.message);
          setTimeout(() => navigate('/login'), 3000);
          return;
        }

        if (data.session) {
          navigate('/dashboard');
        } else {
          navigate('/login');
        }
      } catch (err) {
        setError('Erro ao processar autenticação');
        setTimeout(() => navigate('/login'), 3000);
      }
    };

    handleCallback();
  }, [navigate]);

  return (
    <div 
      className="min-h-screen flex items-center justify-center"
      style={{ backgroundColor: '#FDFBF7' }}
    >
      <div className="text-center space-y-4">
        {error ? (
          <>
            <p style={{ color: '#B75D69' }}>{error}</p>
            <p style={{ color: '#5C6B64' }}>Redirecionando para login...</p>
          </>
        ) : (
          <>
            <Loader2 
              className="h-8 w-8 animate-spin mx-auto" 
              style={{ color: '#4A6B5D' }}
            />
            <p style={{ color: '#5C6B64', fontFamily: 'Figtree, sans-serif' }}>
              Processando autenticação...
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default AuthCallback;
